import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=5b7c7fea&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b7c7fea')) {
      api.createRecord('5b7c7fea', component.options)
    } else {
      api.reload('5b7c7fea', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=5b7c7fea&", function () {
      api.rerender('5b7c7fea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25NPdww4xu75f/JS/imageCarousel.vue"
export default component.exports